export const STATUS_MAPPING = {
  INVOICED_NOT_SELF: 18001, // 非本人开票
  OUT_OF_TIME_RANGE: 18002, // 超出时间范围
  ALREADY_ABANDONED: 18003, // 已作废
  MERCHANT_NOT_EXIST: 17025, // 商户信息不存在
  TAXATION_NOT_EXIST: 17026 // 税盘信息不存在
};

export const INVOICE_STATUS_MAPPING = {
  INVOICED_NOT_SELF: 607, // 非本人开票
  OUT_OF_TIME_RANGE: 608, // 超出时间范围
  ALREADY_ABANDONED: 609, // 已作废
  MERCHANT_NOT_EXIST: 610, // 商户信息不存在
  TAXATION_NOT_EXIST: 611 // 税盘信息不存在
};

export const BIZTYPE_MAP = {
  11: "paotui", // 跑腿业务的biztype
  24: "waimai",// 外卖业务的biztype
  60: "wmshangjia-app-pt" // 跑腿B端开票biztype
};

export const BIZTYPE = {
  WAIMAI: 24, // 外卖业务的biztype
  //啡快和空间预定的bizType
  FeiKuai: 113,
  KongJian: 109,
  ZhuanYeBan_ShouYin: 22, // 专业版收银
  ZhiNengBan_ShouYin: 23, // 智能版收银
  PaoTui: 11, // 跑腿
  PaoTuiB: 110, // 跑腿 B 端
  ShanGou: 137, // 闪购
  XiaoXiangH: 136, // 小象 H 项目
  XiaoXiangN: 139, // 小象 N 项目 
  YiShengHuo: 144 // 易生活
};

export const SUBBIZTYPE = {
  YIYAO: 14090,// 医药业务的subBiztype
  PEISONGFEI: 64151515, // 外卖配送费
  ORDER: 76686 //外卖订单
};

export const APP_CHANNEL_BIZTYPE_MAP = {
  "waimai-mine": 24,
  "QIXING": 108
};

/**
 * H5配送费，不同业务的开票最大可勾选笔数
 */
export const DELIVERY_MAX_SELECT_NUM = {
  WAIMAI: 1000, // 外卖业务
  OTHERS: 100 // 其他业务
}

/**
 * 前台码上报埋点时用于区分业务方、业务场景的参数
 */

export const QIAN_TAI_MA_SOURCE_MAP: Record<string, object> = {
  /**
   * 专业版收银
   */
  [BIZTYPE.ZhuanYeBan_ShouYin]: {
    businessSource: 'zhuanye_shouyin',
    businessSourceFrom: 'zhuanye_shouyin_qiantaima'
  },

  /**
   * 智能版收银
   */
  [BIZTYPE.ZhiNengBan_ShouYin]: {
    businessSource: 'zhineng_shouyin',
    businessSourceFrom: 'zhineng_shouyin_qiantaima'
  },
}

/**
 * 发票内容类型
 */
export const INVOICE_CONTENT_TYPE = {
  GOODS_DETAILS: 0, // 商品明细
  GOODS_CATEGORY: 1  // 商品大类
};